import {FC, useEffect, useMemo} from 'react'

import cn from 'classnames/bind'
import Image from 'next/legacy/image'

import AuthTemplateWrapper from 'components/blocks/auth/AuthTemplateWrapper'
import SignUpForm from 'components/blocks/auth/SignUpForm'
import FormHeader from 'components/blocks/FormHeader'
import {Col, Container, Row} from 'components/elements/grid'
import {posthogTrack, klaviyoTrack} from 'src/utils'
import {useDraftStore} from 'src/utils/contexts/RootStore.context'

import s from './TemplateSignUp.module.scss'

const cx = cn.bind(s)

interface ITemplateSignUpProps {
	className?: string
}

const TemplateSignUp: FC<ITemplateSignUpProps> = ({className}) => {
	const draftStore = useDraftStore()

	useEffect(() => {
		posthogTrack('[AUTH] Sign up page opened')
		klaviyoTrack('Page opened', {page: 'sign up', href: window?.location?.href})
	}, [])

	const headerText = useMemo(
		() =>
			!!draftStore.draftId
				? 'Almost Done! Create an Account to Save Your Document'
				: 'Create an Account',
		[draftStore.draftId],
	)

	return (
		<AuthTemplateWrapper className={cx('wrapper', className)}>
			<Container fluid={'md'}>
				<Row className={s.row}>
					<Col className={s.left} aria-label="New Account Form" role="region" md={8} lg={9}>
						<div className={cx('form-wrapper')}>
							<FormHeader className={cx('form__header')} title={headerText} />
							<SignUpForm className={s.form} />
						</div>
					</Col>

					<Col
						className={cx('sidebar')}
						md={4}
						lg={3}
						aria-label="New Account Sidebar"
						role="region">
						<h3>Free Account!</h3>
						<div className="m-3">
							<Image
								alt="Free Flag"
								src="/icons/free-flag.png"
								layout="intrinsic"
								height="100"
								width="100"
							/>
						</div>
						<p className={cx('sidebar__text')}>
							Creating an account is totally free and will allow you to save your document for
							printing and exporting.
						</p>
					</Col>
				</Row>
			</Container>
		</AuthTemplateWrapper>
	)
}

TemplateSignUp.displayName = 'TemplateSignUp'

export default TemplateSignUp
